import React from 'react';
import { connect } from "react-redux";
import { withRouter } from 'react-router';
import axios from 'axios';
import Navbar from './../Navbar/navbar.jsx';
import Navigation from './../Navigation/navigation.jsx';
import { Button, Spinner, ProgressBar, Accordion, Card, useAccordionToggle, Table } from 'react-bootstrap';
import Loader from 'react-loader-spinner'
import _ from 'lodash'
import Moment from "moment";
import { isLogin } from './../../utils/authentication.js';

import { BACKEND_URL_MAIN as BACKEND_URL } from '../../config.js';


axios.defaults.headers.common['token'] = localStorage.getItem("token")


class IrrelevantInsight extends React.PureComponent {
  state = {
  	data: {
  		docs: null,
  		page: 1
  	}
  }

  componentDidMount(){

    if(!isLogin()){
        this.props.history.push({
            pathname:"/login"
        });
    }

    if(this.props.location.search){
      this.getInsights(this.props.location.search)
    } else{
      this.getInsights('?page=1')
    }
  }

  getInsights = (page)=> {
    axios.get(
      BACKEND_URL + "/v1/insights/flag" + page
    ).then((res) => {
        this.setState({data: res.data})
    }).catch((err) => {
        console.log(err)
    })
  }

  handleNext = (page)=> {
    this.props.history.push(this.props.location.pathname + `?page=${page}`)
    this.setState({data: null})
    this.getInsights(`?page=${page}`)
  }


  render() {
    const { data } = this.state;
    return (
      <div>
        <div className="col-md-12 topbar">
            <Navbar />
        </div>

        <main role="main" className="p-5">
          <div className="my-3 p-3 bg-white rounded shadow-sm">
            <h6 className="border-bottom border-gray pb-2 mb-0">BIS Workspace</h6>
            <div className="card">
              <div className="card-body">
              <h5 className="card-title">BIS Insights - {data && data.docs ? `${data.total} Irrelevent Feed` : 'Loading...'} Results</h5>
              
              {data && data.docs ?
              <Table striped bordered hover size="sm">
                <thead>
                  <tr>
                    <th>Feed ID</th>
                    <th>Reporting User Name</th>
                    <th>User ID</th>
                    <th>Tile</th>
                    <th style={{width: 150}}>Reporting Date</th>
                  </tr>
                </thead>
                <tbody>
                  {data && data.docs && data.docs.map((o, index)=>
                    <tr key={index}>
                      <td>{o.feed_id}</td>
                      <td>{o.full_name}</td>
                      <td>{o.user_id}</td>
                      <td><a href={o.source_url} target="_blank">{o.title}</a></td>
                      <td>{Moment(o.reported_date).fromNow()}</td>
                    </tr>
                  )}
                </tbody>
              </Table> :
              <div style={{textAlign: 'center'}}>
                <Loader
                 type="Oval"
                 color="#00BFFF"
                 height={100}
                 width={100}
                /> 
              </div> }

              { data && data.page !== 1 && <button className="btn btn-sucess btn-sm" onClick={()=> this.handleNext(data.page - 1)}>Previous</button> }
              { data && data.page !== data.pages && <button className="btn btn-sucess btn-sm ml-1" onClick={()=> this.handleNext(data.page + 1)}>Next</button> }

              </div>
            </div>
          </div>
        </main>
      </div>
    );
  }
}

function mapStateToProps(state){
    return { }
}

export default withRouter(connect(
  mapStateToProps
)(IrrelevantInsight))




// WEBPACK FOOTER //
// ./src/components/Insights/IrrelevantInsight.js